import * as React from 'react';
import { observer } from "mobx-react";

import { DropdownView } from 'src/core/ui/dropdown.view';

interface ClientEditorViewProps  {
    clientRequest: DropdownRequest<ClientSummary>;
    value: number | null;
    mode: ControlMode;
    onChanged: (number: ClientSummary | null) => void;
    label?: string;
    required?: boolean;
    onGetErrorMessage?: () => Promise<ValidationError[]>;
}

@observer
export class ClientEditorView extends React.Component<ClientEditorViewProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        let label = this.props.label;
        if (label === undefined) {
            label = 'Customer';
        }
        return (
            <DropdownView
                onGetErrorMessage={this.props.onGetErrorMessage}
                label={label}
                model={this.props.value}
                required={this.props.required}
                disabled={this.props.mode == 'display'}
                onChanged={(item) => { this.props.onChanged(item != null ? item : null) }}
                request={this.props.clientRequest}
                keyField='id'
                textField='displayName'
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/parts/client-editor.view.tsx